import {createStrokeSVG} from './TEMPLATE'

// tabler: mail
export const Envelope_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10',
    'M3 7l9 6l9 -6',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: mail
export const Envelope_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10',
    'M3 7l9 6l9 -6',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
